import type { Route } from './+types/submit';
import { apiFetch } from '~/lib/api-client';
import type { ApiResult, SiteConfig } from '~/lib/types';
import { SubmitFlow } from '~/components/submit-flow';

export function meta(_: Route.MetaArgs) {
  return [
    { title: 'List Your Event — free, under 2 minutes — Tampa Bay Networking Calendar' },
    {
      name: 'description',
      content:
        'Add your networking event to the Tampa Bay calendar in under 2 minutes. Free listings, no account needed. Paste a link or upload a flyer and let AI do the typing.',
    },
    { property: 'og:image', content: '/og-default.png' },
  ];
}

export async function loader({ request }: Route.LoaderArgs) {
  let turnstileSiteKey = '';
  try {
    const res = await apiFetch(request, '/api/config');
    const body = (await res.json().catch(() => null)) as ApiResult<SiteConfig> | null;
    if (body?.ok) turnstileSiteKey = body.data.turnstileSiteKey ?? '';
  } catch {
    // config endpoint unavailable — proceed without Turnstile
  }
  return { turnstileSiteKey };
}

export default function Submit({ loaderData }: Route.ComponentProps) {
  const { turnstileSiteKey } = loaderData;
  return (
    <main className="page">
      <div className="container page-narrow stack">
        <SubmitFlow turnstileSiteKey={turnstileSiteKey} />
      </div>
    </main>
  );
}
